import { render, staticRenderFns } from "./periodical.vue?vue&type=template&id=764b70cc&scoped=true"
import script from "./periodical.vue?vue&type=script&lang=js"
export * from "./periodical.vue?vue&type=script&lang=js"
import style0 from "./periodical.vue?vue&type=style&index=0&id=764b70cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764b70cc",
  null
  
)

export default component.exports